import React from 'react';
import { colors } from 'style/config';

const PATHS = {
    caretDown: (
        <g fill='none'>
            <path
                d='M6 9L12 15L18 9'
                stroke='currentColor'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
    ),

    caretUp: (
        <g fill='none'>
            <path
                d='M6 15L12 9L18 15'
                stroke='currentColor'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
    ),

    box: (
        <g fill='none'>
            <g
                fill='#231F20'
                clipPath='url(#a)'
            >
                <path d='M23.7364 6.18337c-.0171-.02161-.036-.0417-.0565-.06005-.029-.04276-.0646-.08056-.1054-.11194-.008-.00501-.0178-.00368-.0259-.00813-.007-.00392-.01-.01224-.0172-.01584L12.678.580562c-.1324-.065968-.287-.069015-.4218-.008315L.293533 5.97909c-.01114.00508-.016051.01728-.026685.02311-.012777.0068-.027915.00557-.040136.01358-.036044.02939-.067695.06388-.093972.10241-.021152.01925-.0405447.04039-.0579431.06316-.0466608.07562-.07220667.16258-.07393376.25166L0 18.0508c0 .1972.114428.3761.292561.4569L12.1966 23.9141c.1346.0611.2893.0584.4218-.0074l10.912-5.4064c.17-.084.2776-.2584.2776-.4495V6.43643c-.0009-.08932-.0256-.17674-.0716-.25306ZM12.5 1.30172l10.1123 5.15996-4.8759 2.38897L7.32266 3.59391 12.5 1.30172ZM6.53164 3.99996 16.9389 9.32028l-4.6178 2.17962-5.36055-2.67315-5.2418-2.6454 4.81289-2.18139ZM.789844 6.58136 11.904 12.1673V22.938L.789844 17.8377V6.58136ZM23.0321 17.832 12.896 22.8402V12.1553l10.1361-5.00871V17.832Z' />
                <path d='m6.85435 12.3912-3.91906-1.87c-.24706-.1143-.53921-.0066-.6552.2416-.11598.2482-.01259.5444.23186.6643l3.91908 1.87c.06599.0316.13813.048.21118.0479.23221.0002.43347-.1623.48436-.3911.05089-.2288-.06221-.4626-.2722-.5627h-.00002ZM4.67612 13.3425l-1.74083-.8305c-.24706-.1144-.53921-.0066-.6552.2415-.11598.2482-.01259.5444.23186.6643l1.74084.8306c.06598.0316.13813.048.21117.0479.2322.0002.43345-.1623.48434-.3911.05089-.2288-.06221-.4626-.27218-.5627Z' />
            </g>
            <defs>
                <clipPath id='a'>
                    <path
                        fill='#fff'
                        d='M0 0h24v24H0z'
                    />
                </clipPath>
            </defs>
        </g>
    ),

    messages: (
        <g
            fill='none'
            fillRule='evenodd'
        >
            <path d='M0 0h24v24H0z' />
            <path
                d='M20.625 5.389V18.61H3.375V5.39z'
                strokeLinecap='round'
                strokeLinejoin='round'
                stroke='currentColor'
            />
            <path
                stroke='currentColor'
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M4 8l8 6 8-6'
            />
        </g>
    ),

    notifications: (
        <g
            fill='none'
            fillRule='evenodd'
        >
            <path d='M0 0h24v24H0z' />
            <path
                d='M11.04 17.9c-.353 0-.64.268-.64.6 0 .828.718 1.5 1.6 1.5.883 0 1.6-.672 1.6-1.5 0-.332-.286-.6-.64-.6h-1.92z'
                fill='currentColor'
                fillRule='nonzero'
            />
            <path
                d='M11.899 4.55c-.981.18-2.426.71-3.46 1.722-.71.692-1.221 1.618-1.221 2.826v4.265l-2.72 3.912h15.046l-2.762-3.853V9.098c0-1.228-.53-2.164-1.27-2.86-1.057-.992-2.534-1.51-3.613-1.688z'
                stroke='currentColor'
                strokeWidth='1.067'
                strokeLinejoin='round'
            />
        </g>
    ),

    location: (
        <g
            fill='none'
            fillRule='evenodd'
        >
            <path d='M0 0h24v24H0z' />
            <g
                transform='translate(6 4)'
                stroke='currentColor'
            >
                <path d='M6 0C2.683 0 0 2.504 0 5.6 0 9.8 6 16 6 16s6-6.2 6-10.4C12 2.504 9.317 0 6 0h0z' />
                <circle
                    strokeWidth='.8'
                    cx='6'
                    cy='6'
                    r='2.222'
                />
            </g>
        </g>
    ),

    currentLocation: (
        <path d='M21.9 1.5L1.8 9.8c-.2 0-.3.2-.3.4s.1.4.3.4l8 2.4c.6.2 1.1.7 1.3 1.3l2.4 8c.1.3.3.3.5.3s.3-.1.3-.3l8.2-20.2c.1-.2 0-.3-.1-.5-.1-.1-.3-.1-.5-.1m-8 22.5c-.9 0-1.6-.5-1.9-1.4l-2.4-8c0-.1-.1-.2-.3-.3l-8-2.4C.5 11.8 0 11 0 10.1c0-.8.5-1.4 1.2-1.7L21.4.2c.7-.3 1.5-.1 2.1.4.6.6.7 1.4.4 2.1l-8.2 20.1c-.4.7-1.1 1.2-1.8 1.2' />
    ),

    x: (
        <path
            d='m1 1 22 22M23 1 1 23'
            stroke='currentColor'
            strokeWidth='1.5'
            vectorEffect='non-scaling-stroke'
            strokeLinecap='round'
        />
    ),

    search: (
        <path d='M9 0a9 9 0 019 9c0 2.215-.8 4.243-2.127 5.81l7.906 7.909h.002a.752.752 0 010 1.062.752.752 0 01-1.062 0l-7.907-7.909A8.964 8.964 0 019 18a9 9 0 01-9-9 9 9 0 019-9zm0 1.5A7.499 7.499 0 001.5 9c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5S13.143 1.5 9 1.5z' />
    ),

    heart: (
        <path d='M22 3.1c2.7 2.2 2.6 7.2.1 9.7-2.2 2.8-7.4 8.1-9.3 9.6-.5.4-1.1.4-1.6 0-1.8-1.5-7-6.8-9.2-9.6-2.6-2.6-2.7-7.6 0-9.7C4.6.5 9.7.7 12 4.2 14.3.8 19.3.5 22 3.1z' />
    ),

    heartOutline: (
        <path d='M22 3.1c2.7 2.2 2.6 7.2.1 9.7-2.2 2.8-7.4 8.1-9.3 9.6-.5.4-1.1.4-1.6 0-1.8-1.5-7-6.8-9.2-9.6-2.6-2.6-2.7-7.6 0-9.7C4.6.5 9.7.7 12 4.2 14.3.8 19.3.5 22 3.1zm-.7.8c-2.4-2.4-7.2-2-8.9 1.5-.1.3-.4.4-.7.2-.1 0-.2-.1-.2-.2-1.6-3.5-6.5-4-8.9-1.5C.4 5.6.5 10 2.7 12.2c2.2 2.7 7.3 8 9.1 9.4.1.1.2.1.3 0 1.8-1.4 6.9-6.7 9.1-9.5 2.3-2.1 2.4-6.5.1-8.2z' />
    ),

    plus: (
        <path
            d='M12.5 0v24M24 12H0'
            stroke='currentColor'
            strokeWidth={2}
            vectorEffect='non-scaling-stroke'
        />
    ),

    minus: <path d='M24 10v4H0v-4z' />,

    checkmark: <path d='M2.836 10.855L0 13.473l7.418 6.982L24 5.618 21.164 3 7.418 15.218' />,

    infoOutline: (
        <path d='M12 24C5.4 24 0 18.6 0 12S5.4 0 12 0s12 5.4 12 12-5.4 12-12 12zm0-1.1c6 0 10.9-4.9 10.9-10.9S18 1.1 12 1.1 1.1 6 1.1 12 6 22.9 12 22.9zM9.8 9.3h3.3V18h1.1v.5H9.8V18h1.1V9.8H9.8v-.5zm1.9-1.7c-.8 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4c.8 0 1.4.6 1.4 1.4s-.6 1.4-1.4 1.4z' />
    ),

    infoFilled: (
        <g fill='none'>
            <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z'
                fill={colors.inputGray}
            />
            <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M9 3H7V9H9V3ZM9 11H7V13H9V11Z'
                fill={colors.white}
            />
        </g>
    ),

    personalizedInfo: (
        <g fill='none'>
            <circle
                cx='12'
                cy='12'
                r='12'
                fill='#06E3FF'
            />
            <path
                d='M12 24C5.4 24 0 18.6 0 12S5.4 0 12 0s12 5.4 12 12-5.4 12-12 12zm0-1.1c6 0 10.9-4.9 10.9-10.9S18 1.1 12 1.1 1.1 6 1.1 12 6 22.9 12 22.9zM9.8 9.3h3.3V18h1.1v.5H9.8V18h1.1V9.8H9.8v-.5zm1.9-1.7c-.8 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4c.8 0 1.4.6 1.4 1.4s-.6 1.4-1.4 1.4z'
                stroke='currentColor'
                strokeWidth='0'
                strokeLinecap='round'
                strokeLinejoin='round'
                fill='#000000'
            />
        </g>
    ),

    personalizedInfoNoOutline: (
        <g fill='none'>
            <path
                d='M9.8 9.3h3.3V18h1.1v.5H9.8V18h1.1V9.8H9.8v-.5zm1.9-1.7c-.8 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4c.8 0 1.4.6 1.4 1.4s-.6 1.4-1.4 1.4z'
                fill='currentColor'
            />
        </g>
    ),

    truck: (
        <path d='M16.122 4a.46.46 0 0 1 .462.458v2.446h3.212a.46.46 0 0 1 .371.186l3.744 5.069c.058.078.09.173.09.271v5.113a.46.46 0 0 1-.461.457l-2.576.001a3.5 3.5 0 0 1-6.92.053H8.956A3.5 3.5 0 0 1 2.036 18L1.46 18a.46.46 0 0 1-.46-.457V12H.393C.177 12 0 11.774 0 11.5s.177-.5.393-.5H1v-1H.348C.156 10 0 9.774 0 9.5S.156 9 .348 9H1V8H.417C.187 8 0 7.774 0 7.5S.188 7 .417 7H1v-.272a2.74 2.74 0 0 1 2.58-2.723L3.747 4ZM5.5 15a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm12 0a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm0 1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm-12 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm12 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm-12 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm10.16-9.637V4.915H3.747a1.82 1.82 0 0 0-1.824 1.813V7h3.66c.23 0 .417.226.417.5s-.188.5-.417.5h-3.66v1h2.729c.192 0 .348.226.348.5s-.156.5-.348.5H1.923v1h1.684c.216 0 .393.226.393.5s-.177.5-.393.5H1.923v5.085h.101a3.5 3.5 0 0 1 6.956.035h5.04a3.5 3.5 0 0 1 6.956-.035h2.1V12.58l-3.514-4.761H16.12a.46.46 0 0 1-.46-.456ZM18.674 9c.129 0 .25.07.325.187l1.973 3.12c.085.134.095.31.028.455a.393.393 0 0 1-.352.238h-4.207c-.219 0-.397-.197-.397-.44V9.44c0-.243.178-.44.397-.44h2.233Zm-.206.88h-1.631v2.24h3.048l-1.417-2.24ZM9.925 7c.294 0 .535.242.535.536a.538.538 0 0 1-.535.535l-1.39-.001A.537.537 0 0 1 8 7.537C8 7.242 8.24 7 8.535 7h1.39Z' />
    ),

    truckActive: (
        <path d='M16.122 4a.46.46 0 0 1 .462.458v2.446h3.212a.46.46 0 0 1 .371.186l3.744 5.069c.058.078.09.173.09.271L24 18l-3.036.001a3.5 3.5 0 0 1-6.92.053H8.956A3.5 3.5 0 0 1 2.036 18L1 18v-6H.5a.5.5 0 1 1 0-1H1v-1H.5a.5.5 0 1 1 0-1H1V8H.5a.5.5 0 1 1 0-1H1v-.272A2.74 2.74 0 0 1 3.747 4h12.375ZM17.5 15a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm-12 0a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm12 1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm-12 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm12 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm-12 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm13.174-8h-2.233c-.219 0-.397.197-.397.44v3.12c0 .243.178.44.397.44h4.207a.393.393 0 0 0 .352-.238.483.483 0 0 0-.028-.455l-1.973-3.12A.389.389 0 0 0 18.674 9ZM3.5 11H1.926v1H3.5a.5.5 0 1 0 0-1Zm1-2H1.922v1H4.5a.5.5 0 1 0 0-1Zm5.425-2h-1.39A.537.537 0 0 0 8 7.537c.002.294.24.532.535.533h1.39a.536.536 0 0 0 0-1.07ZM5.5 7H1.922v1H5.5a.5.5 0 1 0 0-1Z' />
    ),

    bell: (
        <g fill='none'>
            <path
                stroke='#000'
                strokeLinejoin='round'
                strokeWidth='.833333'
                d='M11.5226 1c1.7687.27469 4.1922 1.08124 5.9276 2.62783 1.2145 1.08235 2.0823 2.53982 2.0823 4.45129v6.67678L23 20H1l2.84311-5.3305V8.07912c0-1.88076.83922-3.32254 2.001-4.40007C7.54342 2.10296 9.9154 1.27961 11.5226 1Z'
                clipRule='evenodd'
            />
            <path
                fill='#000'
                d='M10.8002 21c-.4418 0-.8002.3831-.8002.8573C10 23.0398 10.897 24 12 24c1.1039 0 2-.9602 2-2.1427 0-.4742-.3575-.8573-.7993-.8573h-2.4005Z'
            />
        </g>
    ),

    bag: (
        <path d='M16 2c.82 0 1.464.36 1.947.902.471.528.791 1.23 1.013 1.951.444 1.445.54 3.128.54 4.147H22a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h2.5c0-1.019.096-2.702.54-4.147.222-.722.542-1.423 1.013-1.951C14.536 2.36 15.18 2 16 2Zm6 17H10v2h12v-2Zm0-3H10v2h12v-2Zm0-3H10v2h12v-2Zm0-3H10v2h12v-2Zm-6-7c-.49 0-.876.203-1.2.567-.338.378-.604.927-.804 1.58C13.595 6.452 13.5 8.019 13.5 9h5c0-.981-.095-2.548-.495-3.853-.201-.653-.467-1.202-.804-1.58C16.876 3.203 16.49 3 16 3ZM.5 11h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1Zm2 3h5a.5.5 0 1 1 0 1h-5a.5.5 0 1 1 0-1Zm2 3h3a.5.5 0 1 1 0 1h-3a.5.5 0 1 1 0-1Z' />
    ),

    bagActive: (
        <path d='M16 2c.82 0 1.464.36 1.947.902.471.528.791 1.23 1.013 1.951.444 1.445.54 3.128.54 4.147H22a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h2.5c0-1.019.096-2.702.54-4.147.222-.722.542-1.423 1.013-1.951C14.536 2.36 15.18 2 16 2Zm6 15H10v2h12v-2Zm0-5H10v2h12v-2Zm-6-9c-.49 0-.876.203-1.2.567-.338.378-.604.927-.804 1.58C13.595 6.452 13.5 8.019 13.5 9h5c0-.981-.095-2.548-.495-3.853-.201-.653-.467-1.202-.804-1.58C16.876 3.203 16.49 3 16 3ZM.5 11h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1Zm2 3h5a.5.5 0 1 1 0 1h-5a.5.5 0 1 1 0-1Zm2 3h3a.5.5 0 1 1 0 1h-3a.5.5 0 1 1 0-1Z' />
    ),

    store: (
        <g>
            <path d='M1.5 24a.5.5 0 01-.5-.5v-20a.5.5 0 01.5-.5h21a.5.5 0 01.5.5v20a.5.5 0 01-.5.5h-21zM22 23V4H2v19h20z' />
            <path d='M0 23h24v1H0z' />
            <path d='M7.5 24a.5.5 0 01-.5-.5v-10a.5.5 0 01.5-.5h9a.5.5 0 01.5.5v10a.5.5 0 01-.5.5h-9zm8.5-1v-9H8v9h8z' />
            <path d='M11.5 13h1v11h-1zM1 6V5h22v1zm0 2V7h22v1zm0 2V9h22v1z' />
        </g>
    ),

    storeActive: (
        <path
            fillRule='evenodd'
            d='M22.5 3a.5.5 0 01.5.5V23h1v1H0v-1h1V3.5a.5.5 0 01.5-.5h21zM16 14h-3.5v9H16v-9zm-4.5 0H8v9h3.5v-9zM22 10H2v1h20v-1zm0-2H2v1h20V8zm0-2H2v1h20V6zm0-2H2v1h20V4z'
        />
    ),

    community: (
        <path d='M3.5 3.914H3v-.5a.5.5 0 0 0-1 0v.5h-.5a.5.5 0 1 0 0 1H2v.5a.5.5 0 1 0 1 0v-.5h.5a.5.5 0 0 0 0-1m5.707 1.5.354-.354a.5.5 0 0 0-.708-.707l-.353.354-.354-.354a.5.5 0 0 0-.707.707l.354.354-.354.354a.5.5 0 0 0 .707.707L8.5 6.12l.353.354a.5.5 0 1 0 .708-.707l-.354-.354v.001Zm-3.639-2.5a.509.509 0 0 1-.51-.5c0-.276.214-.5.49-.5h.02a.5.5 0 0 1 0 1m16 5a.509.509 0 0 1-.51-.5c0-.276.214-.5.49-.5h.02a.5.5 0 1 1 0 1M4 22.364c0-.17.013-.334.025-.5H1.038c.275-1.764 2.014-2.695 3.952-2.933.239-.381.515-.738.825-1.061C2.891 17.926 0 19.32 0 22.364a.5.5 0 0 0 .5.5h3.592c-.06-.16-.09-.33-.092-.5m15-10.5c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m0 5c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3m-14-5c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m0 5c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3m13.185 1.006c.31.323.586.68.825 1.062 1.939.237 3.676 1.168 3.95 2.932h-2.985c.013.166.025.33.025.5 0 .176-.036.343-.091.5h3.59c.277 0 .5-.223.5-.5 0-3.044-2.89-4.438-5.814-4.494M6.027 22h11.878c-.25-2.247-2.16-4-4.473-4H10.5a4.507 4.507 0 0 0-4.473 4m12.405 1H5.5a.5.5 0 0 1-.5-.5c0-3.033 2.467-5.5 5.5-5.5h2.932c3.033 0 5.5 2.467 5.5 5.5a.5.5 0 0 1-.5.5m-6.499-13c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m0 5c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3m4.191-13c-.308 0-.585.118-.725.258a.876.876 0 0 0-.313.645c-.021.345.104.714.31.92.455.562 1.336 1.346 2.082 1.955.475-.388 1.542-1.284 2.045-1.914a1.29 1.29 0 0 0 .349-.96c-.009-.154-.056-.437-.271-.608a.409.409 0 0 1-.044-.039c-.168-.169-.54-.308-.925-.239a.917.917 0 0 0-.701.532c-.164.351-.741.351-.905 0a.915.915 0 0 0-.7-.532A1.076 1.076 0 0 0 16.124 2Zm1.355 4.866a.689.689 0 0 1-.434-.153c-.401-.32-1.753-1.426-2.393-2.224-.371-.368-.601-1.013-.564-1.644.032-.553.262-1.027.647-1.332.388-.394 1.097-.597 1.763-.48.381.066.714.228.98.471a1.94 1.94 0 0 1 .982-.472c.66-.114 1.352.081 1.784.5.373.305.595.771.626 1.314.036.631-.194 1.276-.602 1.684-.607.762-1.956 1.864-2.354 2.182a.697.697 0 0 1-.435.154Z' />
    ),

    communityActive: (
        <path d='M17.479 6.865a.704.704 0 0 1-.433-.151c-.517-.414-1.776-1.455-2.393-2.225-.372-.368-.603-1.014-.566-1.644.034-.553.263-1.027.649-1.333.388-.392 1.098-.594 1.762-.48.38.066.713.229.98.472.267-.243.6-.406.981-.472.657-.113 1.352.08 1.785.498.373.307.595.773.627 1.316.036.63-.195 1.276-.604 1.684-.6.756-1.953 1.86-2.352 2.182a.71.71 0 0 1-.436.153M3.5 3.914H3v-.5a.5.5 0 0 0-1 0v.5h-.5a.5.5 0 1 0 0 1H2v.5a.5.5 0 1 0 1 0v-.5h.5a.5.5 0 0 0 0-1m5.707 1.5.354-.354a.5.5 0 0 0-.708-.707l-.353.354-.354-.354a.5.5 0 0 0-.707.707l.354.354-.354.354a.5.5 0 0 0 .707.707L8.5 6.12l.353.354a.5.5 0 1 0 .708-.707l-.354-.354v.001Zm-3.639-2.5a.509.509 0 0 1-.51-.5c0-.276.214-.5.49-.5h.02a.5.5 0 1 1 0 1m16 5a.509.509 0 0 1-.51-.5c0-.276.214-.5.49-.5h.02a.5.5 0 1 1 0 1M4 22.364c0-.17.013-.334.025-.5H1.038c.275-1.764 2.014-2.695 3.952-2.933.239-.381.515-.738.825-1.061C2.891 17.926 0 19.32 0 22.364a.5.5 0 0 0 .5.5h3.592c-.06-.16-.09-.33-.092-.5m14.5.5H5.567a.5.5 0 0 1-.5-.5c0-3.032 2.468-5.5 5.5-5.5H13.5c3.032 0 5.5 2.468 5.5 5.5a.5.5 0 0 1-.5.5m.5-11c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m0 5c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3m-14-5c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m0 5c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3m13.185 1.006c.31.323.586.68.825 1.062 1.939.237 3.676 1.168 3.95 2.932h-2.985c.013.166.025.33.025.5 0 .176-.036.343-.091.5h3.59c.277 0 .5-.223.5-.5 0-3.044-2.89-4.438-5.814-4.494M12 14.864c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3' />
    ),

    reservations: (
        <g>
            <path d='M4.492 16h-.935a.5.5 0 0 0 0 1h.935a.5.5 0 0 0 0-1M8.534 16h-.935a.5.5 0 0 0 0 1h.935a.5.5 0 0 0 0-1M4.492 14h-.935a.5.5 0 0 0 0 1h.935a.5.5 0 0 0 0-1M8.534 14h-.935a.5.5 0 0 0 0 1h.935a.5.5 0 0 0 0-1M12.47 14h-.935a.5.5 0 1 0 0 1h.934a.5.5 0 1 0 0-1M4.492 12h-.935a.5.5 0 0 0 0 1h.935a.5.5 0 0 0 0-1M8.534 12h-.935a.5.5 0 0 0 0 1h.935a.5.5 0 0 0 0-1M12.47 12h-.935a.5.5 0 1 0 0 1h.934a.5.5 0 1 0 0-1M16.47 12h-.935a.5.5 0 1 0 0 1h.935a.5.5 0 1 0 0-1M4.492 10h-.935a.5.5 0 0 0 0 1h.935a.5.5 0 0 0 0-1M8.534 10h-.935a.5.5 0 0 0 0 1h.935a.5.5 0 0 0 0-1M12.47 10h-.935a.5.5 0 1 0 0 1h.934a.5.5 0 1 0 0-1M16.47 10h-.935a.5.5 0 1 0 0 1h.935a.5.5 0 1 0 0-1M16.47 8h-.935a.5.5 0 1 0 0 1h.935a.5.5 0 1 0 0-1M12.47 8h-.935a.5.5 0 1 0 0 1h.935a.5.5 0 1 0 0-1M5.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M14.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M19 14a5 5 0 1 0 0 10 5 5 0 0 0 0-10m0 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8' />
            <path d='m20.892 17.29-2.667 2.851-1.142-1.22a.5.5 0 0 0-.73.684l1.506 1.61a.5.5 0 0 0 .73 0l3.034-3.241a.5.5 0 0 0-.73-.684M12 19H2.5c-.828 0-1.5-.672-1.5-1.5V6h18v7h1V2.5A2.503 2.503 0 0 0 17.5 0h-15A2.503 2.503 0 0 0 0 2.5v15A2.503 2.503 0 0 0 2.5 20H13v-1zM1 2.5C1 1.672 1.672 1 2.5 1h15c.828 0 1.5.672 1.5 1.5V5H1z' />
        </g>
    ),

    reservationsActive: (
        <g>
            <path d='M1 1h18v4H1zM4.492 16h-.935a.5.5 0 0 0 0 1h.935a.5.5 0 0 0 0-1M8.534 16h-.935a.5.5 0 0 0 0 1h.935a.5.5 0 0 0 0-1M4.492 14h-.935a.5.5 0 0 0 0 1h.935a.5.5 0 0 0 0-1M8.534 14h-.935a.5.5 0 0 0 0 1h.935a.5.5 0 0 0 0-1M12.47 14h-.935a.5.5 0 1 0 0 1h.934a.5.5 0 1 0 0-1M4.492 12h-.935a.5.5 0 0 0 0 1h.935a.5.5 0 0 0 0-1M8.534 12h-.935a.5.5 0 0 0 0 1h.935a.5.5 0 0 0 0-1M12.47 12h-.935a.5.5 0 1 0 0 1h.934a.5.5 0 1 0 0-1M16.47 12h-.935a.5.5 0 1 0 0 1h.935a.5.5 0 1 0 0-1M4.492 10h-.935a.5.5 0 0 0 0 1h.935a.5.5 0 0 0 0-1M8.534 10h-.935a.5.5 0 0 0 0 1h.935a.5.5 0 0 0 0-1M12.47 10h-.935a.5.5 0 1 0 0 1h.934a.5.5 0 1 0 0-1M16.47 10h-.935a.5.5 0 1 0 0 1h.935a.5.5 0 1 0 0-1M16.47 8h-.935a.5.5 0 1 0 0 1h.935a.5.5 0 1 0 0-1M12.47 8h-.935a.5.5 0 1 0 0 1h.935a.5.5 0 1 0 0-1' />
            <path
                fill='#fff'
                d='M5.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5M14.5 2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 1 0v-1a.5.5 0 0 0-.5-.5'
            />
            <circle
                cx='19'
                cy='19'
                r='5'
            />
            <path d='M19 14a5 5 0 1 0 0 10 5 5 0 0 0 0-10m0 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8' />
            <path
                fill='#fff'
                d='m20.892 17.29-2.667 2.851-1.142-1.22a.5.5 0 0 0-.73.684l1.506 1.61a.5.5 0 0 0 .73 0l3.034-3.241a.5.5 0 1 0-.73-.684'
            />
            <path d='M12 19H2.5c-.828 0-1.5-.672-1.5-1.5V6h18v7h1V2.5A2.503 2.503 0 0 0 17.5 0h-15A2.503 2.503 0 0 0 0 2.5v15A2.503 2.503 0 0 0 2.5 20H13v-1zM1 2.5C1 1.672 1.672 1 2.5 1h15c.828 0 1.5.672 1.5 1.5V5H1z' />
        </g>
    ),

    offers: (
        <g>
            <path d='M18.346 3.988a1.959 1.959 0 0 0-2.005 1.853 1.957 1.957 0 1 0 3.912.112 1.96 1.96 0 0 0-1.907-1.965Zm-.025 1a.957.957 0 0 1 .932.955.957.957 0 0 1-1.913-.06.956.956 0 0 1 .98-.895Z' />
            <path d='M21.82 1.126 13.488.91a1.47 1.47 0 0 0-1.054.405L.49 12.658a1.47 1.47 0 0 0-.055 2.08l8.118 8.55a1.472 1.472 0 0 0 2.08.051L22.58 11.995c.283-.27.448-.64.457-1.03l.216-8.331a1.469 1.469 0 0 0-1.433-1.508Zm-8.359.784 8.333.216a.47.47 0 0 1 .458.481l-.216 8.333a.47.47 0 0 1-.146.33L9.944 22.614a.472.472 0 0 1-.667-.016l-8.117-8.55a.47.47 0 0 1 .017-.664L13.124 2.04a.471.471 0 0 1 .337-.13Z' />
            <path d='M14.009 9a.504.504 0 0 0-.354.146l-.35.35a2.579 2.579 0 0 0-1.286-.457 2.105 2.105 0 0 0-1.666.603c-1.047 1.046-.282 2.511.092 3.224.729 1.332.499 1.801.261 2.038a1.38 1.38 0 0 1-1.925-.176 3.434 3.434 0 0 1-.782-1.936.498.498 0 0 0-.778-.381.502.502 0 0 0-.22.45 4.59 4.59 0 0 0 .763 2.177l-.36.36a.5.5 0 1 0 .707.707l.351-.351c.423.296.927.458 1.443.463a2.107 2.107 0 0 0 1.508-.606c1.082-1.082.198-2.695-.087-3.217-.57-1.092-.646-1.666-.266-2.045.237-.23.563-.345.892-.313a1.63 1.63 0 0 1 1.033.488c.374.356.549.874.464 1.383a.503.503 0 0 0 .764.523.49.49 0 0 0 .215-.318 2.499 2.499 0 0 0-.425-1.9l.36-.359A.5.5 0 0 0 14.009 9Z' />
        </g>
    ),

    offersActive: (
        <path d='m13.474 1.41 8.333.216a.969.969 0 0 1 .945.995l-.216 8.332-.012.126a.972.972 0 0 1-.289.552L10.288 22.976a.972.972 0 0 1-1.373-.035L.798 14.392a.97.97 0 0 1 .035-1.372L12.781 1.677a.966.966 0 0 1 .693-.267ZM10.78 9.03h-.55v.66c-.287.02-.555.083-.805.19s-.467.252-.65.435c-.39.391-.604.923-.595 1.475 0 .293.04.543.12.75.08.207.205.382.375.525.17.143.383.267.64.37.257.103.562.198.915.285v2.65c-.4-.067-.732-.23-.995-.49s-.402-.613-.415-1.06h-.85c.053.7.277 1.248.67 1.645s.923.628 1.59.695v.82h.55v-.82c.32-.027.613-.093.88-.2.267-.107.497-.252.69-.435.193-.183.345-.402.455-.655.11-.253.165-.543.165-.87 0-.307-.058-.57-.175-.79a1.922 1.922 0 0 0-.425-.55 2.168 2.168 0 0 0-.52-.345 2.725 2.725 0 0 0-.47-.175l-.6-.16v-2.46c.613.113.987.5 1.12 1.16h.85c-.133-.587-.36-1.047-.68-1.38-.32-.333-.75-.533-1.29-.6v-.67Zm0 4.83c.18.053.35.112.51.175.16.063.297.142.41.235.113.093.203.205.27.335.067.13.1.292.1.485 0 .213-.032.398-.095.555-.058.15-.15.283-.27.39-.12.105-.259.185-.41.235-.167.055-.34.089-.515.1v-2.51Zm-.55-3.37v2.34c-.167-.047-.32-.1-.46-.16a1.55 1.55 0 0 1-.365-.215.846.846 0 0 1-.24-.31 1.06 1.06 0 0 1-.085-.445c0-.38.112-.668.335-.865.223-.197.495-.312.815-.345Zm8.117-6.503a1.957 1.957 0 1 0-.102 3.913 1.957 1.957 0 0 0 .102-3.913Zm-.026 1a.957.957 0 1 1-.05 1.913.957.957 0 0 1 .05-1.913Z' />
    ),

    home: (
        <path d='M21.5 24h-6a1.5 1.5 0 01-1.5-1.5v-7a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5v7A1.5 1.5 0 018.5 24h-6A1.5 1.5 0 011 22.5V9.085a1.5 1.5 0 01.661-1.243l9.485-6.393a1.494 1.494 0 011.676 0l9.516 6.404c.414.28.662.746.662 1.245V22.5a1.5 1.5 0 01-1.5 1.5zm-11-10h3a1.5 1.5 0 011.5 1.5v7a.5.5 0 00.5.5h6a.5.5 0 00.5-.5V9.098a.502.502 0 00-.22-.415L12.262 2.28a.494.494 0 00-.558 0L2.22 8.67a.499.499 0 00-.22.414V22.5a.5.5 0 00.5.5h6a.5.5 0 00.5-.5v-7a1.5 1.5 0 011.5-1.5z' />
    ),

    homeActive: (
        <path d='M22.338 7.854v-.001l-9.516-6.404a1.494 1.494 0 0 0-1.676 0L1.661 7.842A1.5 1.5 0 0 0 1 9.085V22.5A1.5 1.5 0 0 0 2.5 24h6a1.5 1.5 0 0 0 1.5-1.5v-7a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v7a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V9.098c0-.5-.248-.966-.662-1.244Z' />
    ),

    shop: (
        <path d='M7.5 0A3.5 3.5 0 0 1 11 3.5V5h3.5c.133 0 .26.053.354.146A.504.504 0 0 1 15 5.5V11h-1V6h-3v1.5a.5.5 0 1 1-1 0V6H5v1.5a.5.5 0 0 1-1 0V6H1v16.5a.5.5 0 0 0 .5.5H8v1H1.5A1.5 1.5 0 0 1 0 22.5v-17c0-.133.053-.26.146-.354A.504.504 0 0 1 .5 5H4V3.5A3.5 3.5 0 0 1 7.5 0Zm16 12c.133 0 .26.053.354.146A.504.504 0 0 1 24 12.5v10a1.5 1.5 0 0 1-1.5 1.5h-12A1.5 1.5 0 0 1 9 22.5v-10c0-.133.053-.26.146-.354A.504.504 0 0 1 9.5 12Zm-.5 1H10v9.5a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V13Zm-3.5 2a.5.5 0 0 1 .5.5v1a3.504 3.504 0 0 1-3.5 3.5 3.504 3.504 0 0 1-3.5-3.5v-1a.5.5 0 1 1 1 0v1a2.5 2.5 0 1 0 5 0v-1a.5.5 0 0 1 .5-.5ZM7.5 1A2.5 2.5 0 0 0 5 3.5V5h5V3.5A2.5 2.5 0 0 0 7.5 1Z' />
    ),

    shopActive: (
        <g>
            <path d='M1 22.5V6h3v1.5a.5.5 0 0 0 1 0V6h5v1.5a.5.5 0 1 0 1 0V6h3v5h1V5.5a.504.504 0 0 0-.146-.354A.504.504 0 0 0 14.5 5H11V3.5a3.5 3.5 0 0 0-7 0V5H.5a.504.504 0 0 0-.354.146A.504.504 0 0 0 0 5.5v17A1.5 1.5 0 0 0 1.5 24H8v-1H1.5a.5.5 0 0 1-.5-.5Zm4-19a2.5 2.5 0 0 1 5 0V5H5V3.5Z' />
            <path d='M23.5 12h-14a.504.504 0 0 0-.354.146A.504.504 0 0 0 9 12.5v10a1.5 1.5 0 0 0 1.5 1.5h12a1.5 1.5 0 0 0 1.5-1.5v-10a.504.504 0 0 0-.146-.354A.504.504 0 0 0 23.5 12ZM20 16.5a3.5 3.5 0 1 1-7 0v-1a.5.5 0 1 1 1 0v1a2.5 2.5 0 1 0 5 0v-1a.5.5 0 1 1 1 0v1Z' />
        </g>
    ),

    me: (
        <g>
            <path d='M12.388.006c6.296.212 11.419 5.33 11.606 11.594.213 6.93-5.443 12.607-12.38 12.394C5.317 23.782.195 18.664.007 12.4-.229 5.57 5.287-.042 12.087 0l.301.005v.001Zm-.031 1.01C5.998.82.797 6.024 1.017 12.37c.171 5.73 4.866 10.418 10.628 10.614 6.35.195 11.534-5 11.338-11.354-.167-5.633-4.707-10.26-10.323-10.6l-.303-.014v.002Z' />
            <path d='M16.007 5.02c.027 0 .027.026.053.026.374 1.786 1.334 4.08 3.76 5.013.347 1.44.32 3.04-.187 4.666-.666 2.001-2.852 4.214-4.852 4.881-4.56 1.546-8.827-.88-10.293-4.72 5.52-1.253 5.093-7.707 5.093-7.707l.03.112c.117.437.5 2.087.157 3.755 4.613-.08 5.893-3.76 6.24-6.027h-.001Zm.13 3.119-.072.146c-1.123 2.26-3.144 3.717-6.28 3.771-.04 0-.08 0-.12-.005l-.075-.012c-.745 1.512-1.887 2.681-3.463 3.37l-.235.097.053.091c1.617 2.77 4.92 4.149 8.271 3.129l.245-.079c1.69-.563 3.646-2.533 4.208-4.222a7.845 7.845 0 0 0 .29-3.516l-.025-.133-.228-.117c-1.034-.553-1.84-1.344-2.446-2.314l-.124-.206Z' />
            <path d='M14.674 17.125c-.054 0-.106.028-.16.028-.56.08-1.093-.108-1.546-.454a.637.637 0 0 0-.374-.134c-.213 0-.374.108-.507.24a.596.596 0 0 0-.48-.266.578.578 0 0 0-.373.134c-.454.346-.986.56-1.546.452-.054 0-.107-.026-.16-.026l-.027.054.533.373c.774.56 1.734.799 2.64.613h.026c.347-.08.694-.212 1.014-.4l.987-.586-.027-.028Zm4.774-4.693v-.026c-1.68-.027-2.134-1.2-2.16-1.253-.48.986-2.934 1.333-3.708.053l-.16.08c.134.266.268 1.573 2.188 2.693v-.027c-.56-.4-.667-.986-.641-1.573.64.854 1.68 1.414 2.053 1.414v-.028c-.693-.24-.96-.853-1.066-1.44.827.72 2.026.988 2.373.908v-.028c-.986-.133-1.226-.613-1.36-1.172.933.505 2.16.56 2.48.4Z' />
        </g>
    ),

    meActive: (
        <g>
            <path d='M23.995 11.6C23.81 5.337 18.685.22 12.39.007 5.452-.207-.232 5.47.007 12.4c.187 6.264 5.31 11.381 11.607 11.594 6.937.213 12.594-5.464 12.38-12.393h.001Zm-4.386 3.126c-.667 2-2.853 4.214-4.854 4.88-4.56 1.52-8.852-.906-10.293-4.72 5.52-1.253 5.093-7.706 5.093-7.706s.587 1.892.187 3.866c4.614-.107 5.893-3.76 6.24-6.027.027 0 .027.027.053.027.374 1.787 1.334 4.053 3.76 5.013.373 1.44.347 3.04-.187 4.667h.001Z' />
            <path d='M14.675 17.127c-.052 0-.106.026-.16.026-.56.08-1.093-.106-1.546-.454a.637.637 0 0 0-.374-.132c-.213 0-.373.106-.506.24a.596.596 0 0 0-.48-.268.578.578 0 0 0-.374.134c-.452.346-.986.56-1.546.454-.053 0-.107-.028-.16-.028l-.027.054.534.374c.773.56 1.733.799 2.64.612h.027c.346-.08.693-.212 1.012-.4l.987-.585-.027-.027Zm4.774-4.694v-.027c-1.68-.027-2.133-1.2-2.16-1.253-.48.986-2.933 1.333-3.707.053l-.16.08c.133.266.267 1.573 2.187 2.694v-.028c-.56-.399-.667-.986-.64-1.573.64.854 1.68 1.415 2.054 1.415v-.028c-.695-.24-.96-.853-1.068-1.44.827.72 2.026.987 2.374.907v-.026c-.987-.134-1.227-.614-1.36-1.175.933.508 2.16.561 2.48.4Z' />
        </g>
    ),

    online: (
        <path d='M8.199 3.796a.484.484 0 0 0-.347.475l.085 14.543a.5.5 0 0 0 .255.434.464.464 0 0 0 .49-.022l2.718-1.934 1.826 4.19c.05.121.146.216.264.264.118.049.25.047.365-.004l3.476-1.587a.479.479 0 0 0 .253-.27.507.507 0 0 0-.008-.377l-1.826-4.191 3.212-.774a.478.478 0 0 0 .35-.355.506.506 0 0 0-.144-.488L8.648 3.912a.47.47 0 0 0-.45-.116zm.62 1.585l9.037 8.418-2.893.692a.474.474 0 0 0-.319.26.506.506 0 0 0-.003.422l1.862 4.28-2.611 1.184-1.863-4.279a.489.489 0 0 0-.306-.273.463.463 0 0 0-.398.065l-2.442 1.727L8.82 5.381zM15.504 5.035a3.529 3.529 0 0 1 3.524 3.525.503.503 0 1 0 1.007 0 3.529 3.529 0 0 1 3.525-3.525.503.503 0 1 0 0-1.007A3.529 3.529 0 0 1 20.035.504a.503.503 0 1 0-1.007 0 3.529 3.529 0 0 1-3.524 3.524.503.503 0 1 0 0 1.007zm4.028-2.445a4.538 4.538 0 0 0 1.942 1.942 4.537 4.537 0 0 0-1.942 1.942 4.538 4.538 0 0 0-1.942-1.942 4.537 4.537 0 0 0 1.942-1.942zM.337 20.369a2.36 2.36 0 0 1 2.358 2.358.337.337 0 1 0 .674 0 2.36 2.36 0 0 1 2.358-2.358.337.337 0 1 0 0-.674 2.36 2.36 0 0 1-2.358-2.358.337.337 0 1 0-.674 0 2.36 2.36 0 0 1-2.358 2.358.337.337 0 1 0 0 .674z' />
    ),

    alert: (
        <g>
            <circle
                fill='#fff'
                cx='12'
                cy='18.667'
                r='1.333'
            />
            <path
                d='M12 5.333c-.8 0-1.333.534-1.333 1.334v8c0 .8.533 1.333 1.333 1.333.8 0 1.333-.533 1.333-1.333v-8c0-.8-.533-1.334-1.333-1.334z'
                fill='#fff'
            />
            <path
                d='M12 0C5.333 0 0 5.333 0 12s5.333 12 12 12 12-5.333 12-12S18.667 0 12 0zm0 20c-.8 0-1.333-.533-1.333-1.333 0-.8.533-1.334 1.333-1.334.8 0 1.333.534 1.333 1.334S12.8 20 12 20zm1.333-5.333c0 .8-.533 1.333-1.333 1.333-.8 0-1.333-.533-1.333-1.333v-8c0-.8.533-1.334 1.333-1.334.8 0 1.333.534 1.333 1.334v8z'
                fill='currentColor'
            />
        </g>
    ),

    filter: (
        <path d='M8.933 16.662c1.411 0 2.587 1.001 2.927 2.348l.099-.006h10.815c.401 0 .726.292.726.652v.148c0 .36-.325.651-.726.651H11.96c-.021 0-.043 0-.064-.002-.282 1.427-1.494 2.51-2.962 2.51-1.467 0-2.68-1.083-2.963-2.511l-.062.003H1.226c-.401 0-.726-.291-.726-.651v-.148c0-.36.325-.652.726-.652h4.682c.033 0 .067.002.1.006.339-1.347 1.514-2.348 2.925-2.348zm0 1.452c-.86 0-1.574.752-1.574 1.698 0 .947.714 1.699 1.574 1.699.861 0 1.575-.752 1.575-1.699 0-.946-.714-1.698-1.575-1.698zm6.134-9.533c1.467 0 2.68 1.082 2.963 2.51l.062-.003h4.682c.401 0 .726.292.726.651v.149c0 .36-.325.651-.726.651h-4.682a.814.814 0 0 1-.1-.006c-.339 1.347-1.514 2.348-2.925 2.348-1.411 0-2.587-1-2.927-2.347l-.099.005H1.226c-.401 0-.726-.292-.726-.651v-.149c0-.36.325-.651.726-.651H12.04c.021 0 .043 0 .064.002.282-1.427 1.494-2.509 2.962-2.509zm0 1.451c-.861 0-1.575.753-1.575 1.7 0 .946.714 1.698 1.575 1.698.86 0 1.574-.752 1.574-1.699 0-.946-.714-1.699-1.574-1.699zM8.933.5c1.411 0 2.586 1 2.927 2.347l.099-.005h10.815c.401 0 .726.292.726.652v.148c0 .36-.325.651-.726.651H11.96c-.021 0-.043 0-.064-.002C11.613 5.718 10.401 6.8 8.933 6.8c-1.467 0-2.68-1.082-2.963-2.51l-.062.003H1.226C.825 4.293.5 4.001.5 3.642v-.148c0-.36.325-.652.726-.652h4.682c.033 0 .067.002.1.006C6.347 1.501 7.522.5 8.932.5zm0 1.451c-.86 0-1.574.753-1.574 1.699 0 .946.714 1.699 1.574 1.699.861 0 1.575-.753 1.575-1.699 0-.946-.714-1.699-1.575-1.699z' />
    ),

    star: (
        <path d='M4.5 24a.735.735 0 0 1-.467-.168.79.79 0 0 1-.228-.896L6.99 14.78.318 9.924a.788.788 0 0 1-.283-.867.752.752 0 0 1 .715-.54h7.758L11.294.512A.733.733 0 0 1 12.03 0a.754.754 0 0 1 .694.57l2.1 7.945h8.427c.327 0 .616.219.715.54a.788.788 0 0 1-.283.868l-6.673 4.855 3.187 8.157a.791.791 0 0 1-.23.896.732.732 0 0 1-.896.028L12 18.752 4.93 23.86A.735.735 0 0 1 4.5 24Z' />
    ),

    autoReplenish: (
        <path d='M11.878 1.002c2.119-.037 4.02.547 5.65 1.498l.889-1.44 2.224 4.13-4.473-.502.859-1.386a9.886 9.886 0 0 0-5.553-1.346c-4.333.23-8.097 3.285-9.188 7.48-1.581 6.062 2.686 12.09 8.973 12.579 4.789.365 9.235-2.82 10.454-7.455.506-1.906.42-3.801-.124-5.526a.482.482 0 0 1 .293-.607.47.47 0 0 1 .614.304 10.928 10.928 0 0 1-.014 6.616c-1.518 4.795-6.219 7.992-11.24 7.624C4.377 22.475-.291 15.978 1.32 9.368c1.178-4.837 5.585-8.29 10.559-8.366Zm1.363 4.487 5.19 2.15c.25.1.37.39.28.65l-1.04 2.51v6.38c0 .2-.12.38-.31.46l-5.19 2.15c-.06.03-.13.04-.19.04s-.13-.01-.19-.04L6.6 17.64a.499.499 0 0 1-.31-.46V10.8L5.18 8.13a.507.507 0 0 1 .11-.55c.14-.14.35-.18.54-.1l3.71 1.53 2.05-.84 1-2.41a.5.5 0 0 1 .65-.27Zm3.422 5.961-4.19 1.73v5.4l4.19-1.74v-5.39ZM7.28 15.76v1.08l4.19 1.74V17.5l-4.19-1.74Zm0-2.16v1.08l4.19 1.74v-1.08L7.28 13.6Zm0-2.16v1.08l4.19 1.74v-1.08l-4.19-1.74Zm4.69-2.35-1.12.47.17.07c.12.05.22.15.27.27l.95 2.3 3.61-1.5-3.88-1.61Zm-5.41-.23.6 1.45 3.88 1.61-.6-1.45-3.88-1.61Zm6.75-2.26-.69 1.68 4.27 1.77.69-1.68-4.27-1.77Z' />
    ),

    autoReplenishActive: (
        <path d='m17.529 2.5.888-1.44 2.224 4.13-4.473-.502.859-1.386a9.886 9.886 0 0 0-5.553-1.346c-4.333.23-8.097 3.285-9.188 7.48-1.581 6.062 2.686 12.09 8.973 12.579 4.789.365 9.235-2.82 10.454-7.455.506-1.906.42-3.801-.124-5.526a.482.482 0 0 1 .293-.607.47.47 0 0 1 .614.304 10.928 10.928 0 0 1-.014 6.616c-1.518 4.795-6.219 7.992-11.24 7.624C4.377 22.475-.291 15.978 1.32 9.368c1.178-4.837 5.585-8.29 10.559-8.366 2.119-.037 4.02.547 5.65 1.498ZM13.24 5.49l5.19 2.15c.25.1.37.39.28.65l-1.04 2.51v6.38c0 .2-.12.38-.31.46l-5.19 2.15c-.06.03-.13.04-.19.04s-.13-.01-.19-.04L6.6 17.64a.499.499 0 0 1-.31-.46V10.8L5.18 8.13a.507.507 0 0 1 .11-.55c.14-.14.35-.18.54-.1l3.71 1.53 2.05-.84 1-2.41a.5.5 0 0 1 .65-.27ZM7.28 15.76v1.08l4.19 1.74V17.5l-4.19-1.74Zm0-2.16v1.08l4.19 1.74v-1.08L7.28 13.6Zm0-2.16v1.08l4.19 1.74v-1.08l-4.19-1.74Zm4.69-2.35-1.12.47.17.07c.12.05.22.15.27.27l.95 2.3 3.61-1.5-3.88-1.61Zm-5.41-.23.6 1.45 3.88 1.61-.6-1.45-3.88-1.61Zm6.75-2.26-.69 1.68 4.27 1.77.69-1.68-4.27-1.77Z' />
    ),

    eye: (
        <g
            fill='none'
            stroke='currentColor'
        >
            <path d='M1.20248 11.453C0.932184 11.7671 0.933628 12.2341 1.20204 12.5472C4.54181 16.4469 8.17422 18.5 12.0001 18.5C15.8265 18.5 19.4581 16.4471 22.7977 12.5469C23.0674 12.2334 23.067 11.7665 22.7988 11.4535C19.4583 7.55309 15.8267 5.5 12.0001 5.5C8.17439 5.5 4.54213 7.55288 1.20248 11.453Z' />
            <path d='M12 16C9.79439 16 8 14.2056 8 12C8 9.79439 9.79439 8 12 8C14.2056 8 16 9.79439 16 12C16 14.2056 14.2056 16 12 16Z' />
        </g>
    ),

    circleCheck: (
        <path d='M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0Zm3.73 8.333-6.345 5.775-2.116-2.063L6 13.284l3.385 3.3L17 9.571l-1.27-1.238Z' />
    ),

    trash: (
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M4.5 1H7.5V2H4.5V1ZM3.5 2V1C3.5 0.447715 3.94772 0 4.5 0H7.5C8.05228 0 8.5 0.447715 8.5 1V2H8.99875H10H10.5C10.7761 2 11 2.22386 11 2.5C11 2.77614 10.7761 3 10.5 3H9.95L9.5475 11.0499C9.52089 11.5821 9.08162 12 8.54875 12H3.45125C2.91838 12 2.47911 11.5821 2.4525 11.0499L2.05 3H1.5C1.22386 3 1 2.77614 1 2.5C1 2.22386 1.22386 2 1.5 2H2H3.00125H3.5ZM7.5 3H4.5H3.05125L3.45125 11L8.54875 11L8.94875 3H7.5ZM4.5 4.5C4.5 4.22386 4.72386 4 5 4C5.27614 4 5.5 4.22386 5.5 4.5V9.5C5.5 9.77614 5.27614 10 5 10C4.72386 10 4.5 9.77614 4.5 9.5V4.5ZM7 4C6.72386 4 6.5 4.22386 6.5 4.5V9.5C6.5 9.77614 6.72386 10 7 10C7.27614 10 7.5 9.77614 7.5 9.5V4.5C7.5 4.22386 7.27614 4 7 4Z'
            fill='black'
        />
    ),

    giftBox: (
        <path
            fill='#000'
            fillRule='evenodd'
            d='M22.4365 11.8879h-.7095v.0001h.7093v9.4944c0 .1418-.0975.2618-.2341.3069.1368-.045.2343-.1651.2343-.307v-9.4944Zm-20.95322.0001h.70933v9.1684h9.45169v-.0001H2.19282v-9.1684h-.70954v.0001ZM.531269 6.38848c.036313-.01146.075326-.01768.115979-.01768H5.46144c-.00003-.00003-.00006-.00005-.00009-.00007H.64745c-.040728 0-.07981.00625-.116181.01775ZM6.39509 1.44967c.32008-.10232.66369-.15794 1.02112-.15794 1.17995 0 2.24496.60897 2.77849 1.58892l1.8051 3.12046.0001-.0002-1.805-3.12032c-.53352-.97996-1.59854-1.58892-2.77849-1.58892-.3575 0-.70118.05564-1.02132.158Zm9.16021.00286c.3247-.10504.6715-.16086 1.029-.16086 1.7192 0 3.117 1.28574 3.117 2.86553 0 .74353-.3158 1.4144-.8247 1.92186-.1047.10441-.2176.20189-.3375.29167h4.8134c.1959 0 .3548.1454.3548.32535v4.35142c0 .1413-.098.2614-.235.3064.1369-.0451.2348-.1651.2348-.3063V6.69614c0-.17995-.1589-.32534-.3548-.32534h-4.8134c.7031-.52617 1.1622-1.31704 1.1622-2.21354 0-1.57979-1.3978-2.86553-3.117-2.86553-.3574 0-.7042.0558-1.0288.1608Zm6.1715 19.60377h-9.3727v-9.6834h-.0002v9.6835h9.3729v-.0001Zm-.2925-9.3918v9.1002h-8.7876v-9.1002h8.7876Zm1.2949 9.7178v-9.7178h.6233c.3339 0 .6475-.2534.6475-.617V6.69608c0-.36358-.3136-.61702-.6475-.61702h-4.0789c.4464-.52761.7204-1.1905.7204-1.92186C19.994 2.39467 18.4425 1 16.5843 1c-1.2793 0-2.4459.65988-3.0347 1.73812L12 5.41703l-1.5497-2.67894C9.8616 1.6599 8.69506 1 7.41641 1 5.55903 1 4.00603 2.39455 4.00603 4.1572c0 .73143.27442 1.39431.72098 1.92186H.64745c-.334992 0-.64745.2538-.64745.61702v4.35142c0 .3632.312458.617.64745.617h.54315v9.7178c0 .3639.31317.6177.64745.6177H22.0825c.3351 0 .6467-.2545.6467-.6177Zm-20.2437-.6176v-9.1002h8.8663v9.1002H2.4855ZM18.6991 4.1572c0-1.0378-.9263-1.92187-2.1148-1.92187-.8027 0-1.5159.41051-1.8775 1.05806l-.0005.00191-.0111.01912-.0129.02368-.0028.00354-1.5827 2.73677h3.4875c1.1886 0 2.1148-.88412 2.1148-1.92121Zm-4.2654-.97474-1.8434 3.18762h3.994c.2761 0 .5415-.04295.7887-.12197-.2473.07906-.5127.12203-.7889.12203h-3.994l1.8434-3.18761c.0007-.00261.0021-.00457.0043-.00718.2882-.53111.777-.92164 1.3566-1.10852-.5796.1869-1.0682.57741-1.3564 1.10846-.0022.00261-.0036.00456-.0043.00717Zm-7.01729-.94713c.81037 0 1.53034.41918 1.889 1.0789.00349.00641.0069.01212.00888.01537l1.58901 2.74881H7.41641c-1.18935 0-2.11548-.88417-2.11548-1.92121 0-1.03775.92619-1.92187 2.11548-1.92187Zm3.99299 4.13475.0001.00006H7.41621c-1.32825 0-2.40816-.99299-2.40816-2.21288 0-.96669.67742-1.79064 1.61912-2.09156-.94159.30097-1.61892 1.12487-1.61892 2.0915 0 1.21989 1.07991 2.21288 2.40816 2.21288h3.99299Zm.9447.65271h-.0002v3.69881h10.6437v-.0001H12.3541V7.02279Zm.2926.29161h10.0584v3.1154H12.6467V7.3144ZM1.00222 7.02279h-.00021v3.69881H11.6443v-.0001H1.00222V7.02279Zm.29268.29161h10.0569v3.1154H1.2949V7.3144Z'
            clipRule='evenodd'
        />
    ),

    radioCircle: (
        <circle
            cx='8'
            cy='8'
            r='7'
            fill='white'
            stroke='#D9D9D9'
            strokeWidth='2'
        />
    ),

    morning: (
        <g fill='none'>
            <path
                d='M25.0004 18H1'
                stroke='black'
                strokeWidth='1.65625'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M12.9992 9.3993V6'
                stroke='black'
                strokeWidth='1.65625'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M21.6384 9.36133L19.072 11.9276'
                stroke='black'
                strokeWidth='1.65625'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M4.36145 9.36133L6.91951 11.9193'
                stroke='black'
                strokeWidth='1.65625'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M18.9476 17.9997C18.9476 14.7147 16.2846 12.0518 12.9997 12.0518C9.71473 12.0518 7.05176 14.7147 7.05176 17.9997'
                stroke='black'
                strokeWidth='1.65625'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M24.9999 18H21.5684'
                stroke='black'
                strokeWidth='1.65625'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
    ),

    afternoon: (
        <g fill='none'>
            <path
                d='M25.0004 13H21.5689'
                stroke='black'
                strokeWidth='1.65625'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M4.41475 13H1'
                stroke='black'
                strokeWidth='1.65625'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M12.9997 4.3993V1'
                stroke='black'
                strokeWidth='1.65625'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M12.9997 21.5557V25.0001'
                stroke='black'
                strokeWidth='1.65625'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M21.638 4.36133L19.0716 6.92764'
                stroke='black'
                strokeWidth='1.65625'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M6.94192 19.0566L4.36102 21.6373'
                stroke='black'
                strokeWidth='1.65625'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M21.639 21.6391L19.0505 19.0508'
                stroke='black'
                strokeWidth='1.65625'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M4.36102 4.36133L6.91908 6.91932'
                stroke='black'
                strokeWidth='1.65625'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M13.0004 18.9486C16.2853 18.9486 18.9483 16.2856 18.9483 13.0007C18.9483 9.71571 16.2853 7.05273 13.0004 7.05273C9.7154 7.05273 7.05243 9.71571 7.05243 13.0007C7.05243 16.2856 9.7154 18.9486 13.0004 18.9486Z'
                stroke='black'
                strokeWidth='1.65625'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
    ),

    evening: (
        <g fill='none'>
            <g clipPath='url(#clip0_15151_23196)'>
                <path
                    d='M12.5798 23.9983C9.72644 23.9984 6.95782 23.0285 4.72841 21.2477C2.499 19.4668 0.941265 16.981 0.310914 14.1981C-0.319437 11.4153 0.0150527 8.50081 1.25947 5.93313C2.5039 3.36545 4.58431 1.29713 7.1592 0.0677012C7.29046 0.00501031 7.43794 -0.0154442 7.58131 0.0091545C7.72468 0.0337532 7.8569 0.102195 7.95976 0.205055C8.06262 0.307916 8.13106 0.440135 8.15566 0.583507C8.18026 0.726878 8.1598 0.87435 8.09711 1.00561C7.10336 3.09041 6.77995 5.43189 7.17136 7.70801C7.56276 9.98413 8.64976 12.0831 10.2828 13.7162C11.9159 15.3492 14.0149 16.4362 16.291 16.8276C18.5671 17.219 20.9086 16.8956 22.9934 15.9019C23.1246 15.8392 23.2721 15.8187 23.4155 15.8433C23.5589 15.8679 23.6911 15.9364 23.7939 16.0392C23.8968 16.1421 23.9652 16.2743 23.9898 16.4177C24.0144 16.5611 23.994 16.7085 23.9313 16.8398C22.9113 18.9855 21.303 20.7975 19.2934 22.0648C17.2838 23.3321 14.9556 24.0026 12.5798 23.9983ZM6.09715 2.31593C4.77748 3.25933 3.67908 4.4788 2.8783 5.88957C2.07751 7.30034 1.59356 8.86858 1.46008 10.4853C1.32659 12.102 1.54677 13.7284 2.10532 15.2514C2.66387 16.7744 3.54738 18.1575 4.69445 19.3045C5.84152 20.4516 7.22462 21.3351 8.74763 21.8937C10.2706 22.4522 11.897 22.6724 13.5137 22.5389C15.1304 22.4054 16.6987 21.9215 18.1094 21.1207C19.5202 20.3199 20.7397 19.2215 21.6831 17.9018C19.5204 18.5284 17.2291 18.5631 15.0485 18.0023C12.8678 17.4415 10.8775 16.3058 9.28539 14.7136C7.69324 13.1215 6.55753 11.1312 5.99673 8.95054C5.43594 6.76986 5.47062 4.47864 6.09715 2.31593Z'
                    fill='black'
                />
            </g>
            <defs>
                <clipPath id='clip0_15151_23196'>
                    <rect
                        width='24'
                        height='23.9995'
                        fill='white'
                        transform='translate(0 -0.000976562)'
                    />
                </clipPath>
            </defs>
        </g>
    ),

    files: (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                fillRule='evenodd'
                d='M19 7.5V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V4C5 3.44772 5.44772 3 6 3H14.5V6C14.5 6.82843 15.1716 7.5 16 7.5H19ZM18.5858 6.5L15.5 3.41421V6C15.5 6.27614 15.7239 6.5 16 6.5H18.5858ZM4 4C4 2.89543 4.89543 2 6 2H14.6716C15.202 2 15.7107 2.21071 16.0858 2.58579L19.4142 5.91421C19.7893 6.28929 20 6.79799 20 7.32843V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4Z'
                fill='black'
            />
        </svg>
    ),

    shuffle: (
        <path
            d='M17.3366 10.8232C17.031 10.5177 16.5357 10.5177 16.23 10.8232C15.9245 11.1288 15.9245 11.6242 16.23 11.9298L17.3286 13.0283H16.5979C15.887 13.0283 15.1938 12.7787 14.6459 12.3256L11.8339 9.99995L14.6458 7.67434C15.1938 7.22123 15.887 6.97163 16.5979 6.97163H17.3286L16.23 8.07024C15.9245 8.37582 15.9245 8.87118 16.23 9.17676C16.3829 9.32951 16.5831 9.40592 16.7833 9.40592C16.9835 9.40592 17.1837 9.32951 17.3365 9.17676L19.7708 6.74256C20.0763 6.43698 20.0763 5.94162 19.7708 5.63604L17.3365 3.20184C17.0309 2.89626 16.5356 2.89626 16.2299 3.20184C15.9244 3.50742 15.9244 4.00278 16.2299 4.30836L17.3286 5.40688H16.5978C15.5238 5.40688 14.4763 5.78392 13.6484 6.46845L10.6062 8.98463L7.17776 6.14922C6.59894 5.67047 5.86642 5.40679 5.1153 5.40679H0.782422C0.350264 5.40679 0 5.75706 0 6.18921C0 6.62137 0.350264 6.97163 0.782422 6.97163H5.11539C5.50329 6.97163 5.88155 7.10778 6.18052 7.35511L9.37854 9.99995L6.18061 12.6448C5.88164 12.892 5.50329 13.0283 5.11539 13.0283H0.782422C0.350264 13.0283 0 13.3785 0 13.8107C0 14.2429 0.350264 14.5931 0.782422 14.5931H5.11539C5.86651 14.5931 6.59894 14.3294 7.17794 13.8507L10.6062 11.0154L13.6486 13.5315C14.4763 14.2162 15.5238 14.5931 16.5979 14.5931H17.3286L16.23 15.6916C15.9245 15.9972 15.9245 16.4926 16.23 16.7982C16.3829 16.9509 16.5831 17.0273 16.7833 17.0273C16.9835 17.0273 17.1837 16.9509 17.3365 16.7982L19.7708 14.364C20.0763 14.0584 20.0763 13.563 19.7708 13.2574L17.3366 10.8232Z'
            fill='black'
        />
    ),

    lock: (
        <svg
            viewBox='0 0 11 17'
            fill='currentColor'
        >
            <path d='M3 6.5V3.4C3 2.1 4.1 1 5.5 1S8 2.1 8 3.4v3.1c0 .3.2.5.5.5s.5-.2.5-.5V3.4C9 1.5 7.4 0 5.5 0S2 1.5 2 3.4v3.1c0 .3.2.5.5.5s.5-.2.5-.5zM9.8 7H1.2C.6 7 0 7.6 0 8.3v7.4c0 .7.6 1.3 1.2 1.3h8.5c.7 0 1.2-.6 1.2-1.3V8.3C11 7.6 10.4 7 9.8 7zm.2 8.7c0 .1-.1.3-.2.3H1.2c-.1 0-.2-.1-.2-.3V8.3c0-.1.1-.3.2-.3h8.5c.1 0 .2.1.2.3v7.4z'></path>
            <path d='M5.5 10c-.3 0-.5.3-.5.6v2.9c0 .2.2.5.5.5s.5-.3.5-.6v-2.9c0-.2-.2-.5-.5-.5z'></path>
        </svg>
    ),

    gladChat: (
        <g fill='none'>
            <path
                d='m21.87 21.733.837.224-.224-.837-1.158-4.327A10.466 10.466 0 0 0 22.479 12c0-5.798-4.696-10.5-10.49-10.5C6.196 1.5 1.5 6.202 1.5 12c0 5.799 4.696 10.5 10.49 10.5 2.195 0 4.233-.676 5.918-1.83l3.962 1.063z'
                stroke='currentColor'
            />
        </g>
    ),
    gladChatUnavailable: (
        <g fill='none'>
            <path
                d='M10.9893 3C5.47237 3 1 7.47715 1 13C1 18.5228 5.47237 23 10.9893 23C13.1621 23 15.1729 22.3056 16.8122 21.1263L21 22.2496L19.7911 17.7331C20.5487 16.3241 20.9786 14.7123 20.9786 13'
                stroke='currentColor'
                stroke-linecap='round'
                stroke-linejoin='round'
            ></path>
            <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M10.9893 3.5C5.74902 3.5 1.5 7.75279 1.5 13C1.5 18.2472 5.74902 22.5 10.9893 22.5C13.0538 22.5 14.9631 21.8405 16.5202 20.7204C16.642 20.6328 16.7968 20.6045 16.9417 20.6434L20.2931 21.5423L19.3081 17.8624C19.2752 17.7393 19.2904 17.6084 19.3507 17.4963C20.0702 16.1583 20.4786 14.6276 20.4786 13C20.4786 12.7239 20.7025 12.5 20.9786 12.5C21.2548 12.5 21.4786 12.7239 21.4786 13C21.4786 14.7256 21.0624 16.3553 20.3246 17.7926L21.483 22.1203C21.5292 22.2929 21.4798 22.477 21.3535 22.6033C21.2271 22.7295 21.043 22.7788 20.8705 22.7325L16.9083 21.6697C15.2235 22.8244 13.1846 23.5 10.9893 23.5C5.19572 23.5 0.5 18.7985 0.5 13C0.5 7.20151 5.19572 2.5 10.9893 2.5C11.2655 2.5 11.4893 2.72386 11.4893 3C11.4893 3.27614 11.2655 3.5 10.9893 3.5Z'
            ></path>
            <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M17.5 11C19.9853 11 22 8.98528 22 6.5C22 4.01472 19.9853 2 17.5 2C15.0147 2 13 4.01472 13 6.5C13 8.98528 15.0147 11 17.5 11ZM17.5 12C20.5376 12 23 9.53757 23 6.5C23 3.46243 20.5376 1 17.5 1C14.4624 1 12 3.46243 12 6.5C12 9.53757 14.4624 12 17.5 12Z'
                fill='currentColor'
            ></path>
            <path
                fill-rule='evenodd'
                clip-rule='evenodd'
                d='M13.6917 9.88482L20.4609 2.69251L21.1284 3.32076L14.3592 10.5131L13.6917 9.88482Z'
                fill='currentColor'
            ></path>
        </g>
    ),
    upArrow: (
        <svg
            viewBox='0 0 14 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M6.87951 16C7.3017 16 7.64389 15.6578 7.64389 15.2356V2.95382L12.1494 8.43111C12.3005 8.61482 12.5196 8.70986 12.7403 8.70986C12.911 8.70986 13.0832 8.65278 13.2254 8.53558C13.5515 8.26753 13.5984 7.78597 13.3301 7.45958L7.42298 0.278744C7.27902 0.103701 7.06449 0.00152876 6.83772 0C6.60841 0.00458628 6.39514 0.0978406 6.24864 0.270845L0.180481 7.45194C-0.0918933 7.77451 -0.0513812 8.25658 0.270932 8.52921C0.593501 8.80184 1.07582 8.76132 1.3482 8.43901L6.11513 2.79789V15.2356C6.11513 15.6578 6.45731 16 6.87951 16Z'
                fill='white'
            />
        </svg>
    ),
    gallery: (
        <g fill='none'>
            <path
                d='M16.4146 10.6782C15.6959 9.65622 13.5977 9.16671 12.5184 10.6758C12.0325 8.88979 9.89301 8.62941 8.86191 9.34175C7.68494 9.96953 7.50813 11.8149 8.2269 12.8369C8.95359 14.1594 10.6835 16.16 11.2233 16.7715C11.319 16.8801 11.477 16.9081 11.6048 16.8391C12.3249 16.4504 14.6463 15.1668 15.7901 14.1752C16.8213 13.4628 17.2998 11.6708 16.4146 10.6782Z'
                stroke='black'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
            <path
                d='M11.4971 3.90088V5.83607'
                stroke='black'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
            <path
                d='M12.4732 4.86841H10.5205'
                stroke='black'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
            <path
                d='M16.0926 3.21655L14.7119 4.58493'
                stroke='black'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
            <path
                d='M16.0926 4.58493L14.7119 3.21655'
                stroke='black'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
            <path
                d='M10.5303 1.96753H10.5495'
                stroke='black'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
            <path
                d='M13.4595 1H13.4787'
                stroke='black'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
            <path
                d='M13.4285 6.81787H19.3225C19.8617 6.81787 20.2988 7.25106 20.2988 7.78547V18.429C20.2988 18.9634 19.8617 19.3966 19.3225 19.3966H4.6775C4.13828 19.3966 3.70117 18.9634 3.70117 18.429V7.78547C3.70117 7.25106 4.13828 6.81787 4.6775 6.81787H7.57799'
                stroke='black'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
            <path
                d='M9.51587 6.81787H9.55497'
                stroke='black'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
            <path
                d='M17.8329 4.88281H20.787C21.5958 4.88281 22.2515 5.53265 22.2515 6.33421V21.8157C22.2515 22.6173 21.5958 23.2671 20.787 23.2671H3.21303C2.40424 23.2671 1.74854 22.6173 1.74854 21.8157V6.33421C1.74854 5.53265 2.40424 4.88281 3.21303 4.88281H8.07721'
                stroke='black'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
        </g>
    ),
    shareLink: (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M8.5 7H6C4.89543 7 4 7.89543 4 9V21C4 22.1046 4.89543 23 6 23H18C19.1046 23 20 22.1046 20 21V9C20 7.89543 19.1046 7 18 7H15.5'
                stroke='black'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
            <path
                d='M12 15.5V1'
                stroke='black'
                stroke-linecap='round'
            />
            <path
                d='M8.5 5L12 1L15.5 5'
                stroke='black'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
        </svg>
    ),
    buyItAgain: (
        <g fill='none'>
            <g clip-path='url(#clip0_269_6)'>
                <path
                    d='M13.1947 6.92408L13.816 7.47945L9.58563 12.2119L6.7228 9.80971L7.25846 9.17134L9.50287 11.0539L13.1947 6.92408Z'
                    fill='black'
                />
                <path
                    d='M4.45554 4.57859L5.42611 8.20081L4.62117 8.4165L3.86628 5.59921L1.049 6.3541L0.833319 5.54916L4.45554 4.57859Z'
                    fill='black'
                />
                <path
                    d='M3.89279 5.39786C1.35111 8.77078 2.02497 13.5655 5.39789 16.1072C8.77081 18.6489 13.5655 17.975 16.1072 14.6021C17.6598 12.5417 18.0125 9.95086 17.2832 7.66707C16.8185 6.21214 15.9147 4.88185 14.6021 3.89276C13.3722 2.96593 11.9532 2.46667 10.5233 2.36995'
                    stroke='black'
                />
            </g>
            <defs>
                <clipPath id='clip0_269_6'>
                    <rect
                        width='20'
                        height='20'
                        fill='white'
                    />
                </clipPath>
            </defs>
        </g>
    ),
    aiBeauty: (
        <g fill='none'>
            <path
                d='M12.5547 1.01465C13.4211 1.05861 14.2605 1.20506 15.0625 1.43848C14.9598 1.82566 14.7598 2.18357 14.4717 2.47168C14.1514 2.79192 13.7459 3.00669 13.3086 3.0957C13.0316 3.05493 12.7505 3.02655 12.4658 3.01172L11.9824 3C7.02209 3.0039 3 7.03089 3 12L3.01172 12.4775C3.25881 17.226 7.18574 20.9998 11.9893 21C13.7984 20.9999 15.4806 20.4634 16.8916 19.542L17.6396 19.0537L20.5938 19.8457L19.7334 16.6309L20.0635 15.957C20.6108 14.8398 20.9339 13.5947 20.9736 12.2773L20.9785 12L20.9668 11.5508C20.9537 11.2848 20.9272 11.0221 20.8916 10.7627C20.9709 10.2983 21.1908 9.86588 21.5283 9.52832C21.8125 9.24411 22.1639 9.0428 22.5449 8.93848C22.8258 9.91056 22.9785 10.9374 22.9785 12L22.9727 12.3379C22.9241 13.9473 22.5285 15.4711 21.8594 16.8369L22.9648 20.9639L22.9912 21.0967C23.0259 21.3642 22.953 21.6353 22.7891 21.8496L22.7002 21.9521C22.4742 22.1779 22.1575 22.2836 21.8457 22.2432L21.7119 22.2168L17.9844 21.2168C16.2598 22.3428 14.2002 22.9999 11.9893 23C6.10884 22.9998 1.3088 18.3766 1.01465 12.5654L1 12C1 5.92603 5.91922 1.0002 11.9893 1L12.5547 1.01465Z'
                fill='url(#aiBeauty_gradient_inactive)'
            />
            <path
                d='M18 0C18.2273 0 18.4457 0.0902311 18.6064 0.250977C18.7671 0.411709 18.8574 0.630159 18.8574 0.857422C18.8588 1.99355 19.3109 3.08237 20.1143 3.88574C20.9176 4.68911 22.0064 5.14117 23.1426 5.14258C23.3698 5.14258 23.5883 5.2329 23.749 5.39355C23.9098 5.5543 24 5.77267 24 6C24 6.22733 23.9098 6.4457 23.749 6.60645C23.5883 6.7671 23.3698 6.85742 23.1426 6.85742C22.0064 6.85883 20.9176 7.31089 20.1143 8.11426C19.3109 8.91763 18.8588 10.0064 18.8574 11.1426C18.8574 11.3698 18.7671 11.5883 18.6064 11.749C18.4457 11.9098 18.2273 12 18 12C17.7727 12 17.5543 11.9098 17.3936 11.749C17.2329 11.5883 17.1426 11.3698 17.1426 11.1426C17.1412 10.0064 16.6891 8.91763 15.8857 8.11426C15.0824 7.31089 13.9936 6.85883 12.8574 6.85742C12.6302 6.85742 12.4117 6.7671 12.251 6.60645C12.0902 6.4457 12 6.22733 12 6C12 5.77267 12.0902 5.5543 12.251 5.39355C12.4117 5.2329 12.6302 5.14258 12.8574 5.14258C13.9936 5.14117 15.0824 4.68911 15.8857 3.88574C16.6891 3.08237 17.1412 1.99355 17.1426 0.857422C17.1426 0.630159 17.2329 0.411709 17.3936 0.250977C17.5543 0.0902311 17.7727 0 18 0Z'
                fill='black'
            />
            <defs>
                <linearGradient
                    id='aiBeauty_gradient_inactive'
                    x1='1'
                    y1='12'
                    x2='22.9997'
                    y2='12'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#D8ACFF' />
                    <stop
                        offset='1'
                        stopColor='#FFCAA7'
                    />
                </linearGradient>
            </defs>
        </g>
    ),
    aiBeautyDesktop: (
        <g fill='none'>
            <path
                d='M12.5547 1.01465C13.4211 1.05861 14.2605 1.20506 15.0625 1.43848C14.9598 1.82566 14.7598 2.18357 14.4717 2.47168C14.1514 2.79192 13.7459 3.00669 13.3086 3.0957C13.0316 3.05493 12.7505 3.02655 12.4658 3.01172L11.9824 3C7.02209 3.0039 3 7.03089 3 12L3.01172 12.4775C3.25881 17.226 7.18574 20.9998 11.9893 21C13.7984 20.9999 15.4806 20.4634 16.8916 19.542L17.6396 19.0537L20.5938 19.8457L19.7334 16.6309L20.0635 15.957C20.6108 14.8398 20.9339 13.5947 20.9736 12.2773L20.9785 12L20.9668 11.5508C20.9537 11.2848 20.9272 11.0221 20.8916 10.7627C20.9709 10.2983 21.1908 9.86588 21.5283 9.52832C21.8125 9.24411 22.1639 9.0428 22.5449 8.93848C22.8258 9.91056 22.9785 10.9374 22.9785 12L22.9727 12.3379C22.9241 13.9473 22.5285 15.4711 21.8594 16.8369L22.9648 20.9639L22.9912 21.0967C23.0259 21.3642 22.953 21.6353 22.7891 21.8496L22.7002 21.9521C22.4742 22.1779 22.1575 22.2836 21.8457 22.2432L21.7119 22.2168L17.9844 21.2168C16.2598 22.3428 14.2002 22.9999 11.9893 23C6.10884 22.9998 1.3088 18.3766 1.01465 12.5654L1 12C1 5.92603 5.91922 1.0002 11.9893 1L12.5547 1.01465Z'
                fill='url(#aiBeauty_gradient_active_desktop)'
            />
            <path
                d='M18 0C18.2273 0 18.4457 0.0902311 18.6064 0.250977C18.7671 0.411709 18.8574 0.630159 18.8574 0.857422C18.8588 1.99355 19.3109 3.08237 20.1143 3.88574C20.9176 4.68911 22.0064 5.14117 23.1426 5.14258C23.3698 5.14258 23.5883 5.2329 23.749 5.39355C23.9098 5.5543 24 5.77267 24 6C24 6.22733 23.9098 6.4457 23.749 6.60645C23.5883 6.7671 23.3698 6.85742 23.1426 6.85742C22.0064 6.85883 20.9176 7.31089 20.1143 8.11426C19.3109 8.91763 18.8588 10.0064 18.8574 11.1426C18.8574 11.3698 18.7671 11.5883 18.6064 11.749C18.4457 11.9098 18.2273 12 18 12C17.7727 12 17.5543 11.9098 17.3936 11.749C17.2329 11.5883 17.1426 11.3698 17.1426 11.1426C17.1412 10.0064 16.6891 8.91763 15.8857 8.11426C15.0824 7.31089 13.9936 6.85883 12.8574 6.85742C12.6302 6.85742 12.4117 6.7671 12.251 6.60645C12.0902 6.4457 12 6.22733 12 6C12 5.77267 12.0902 5.5543 12.251 5.39355C12.4117 5.2329 12.6302 5.14258 12.8574 5.14258C13.9936 5.14117 15.0824 4.68911 15.8857 3.88574C16.6891 3.08237 17.1412 1.99355 17.1426 0.857422C17.1426 0.630159 17.2329 0.411709 17.3936 0.250977C17.5543 0.0902311 17.7727 0 18 0Z'
                fill='black'
            />
            <defs>
                <linearGradient
                    id='aiBeauty_gradient_active_desktop'
                    x1='1'
                    y1='12'
                    x2='22.9997'
                    y2='12'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#D8ACFF' />
                    <stop
                        offset='1'
                        stopColor='#FFCAA7'
                    />
                </linearGradient>
            </defs>
        </g>
    ),
    aiBeautyActive: (
        <g fill='none'>
            <path
                d='M12.5537 1.01465C13.4204 1.05859 14.2603 1.20497 15.0625 1.43848C14.9598 1.82566 14.7598 2.18357 14.4717 2.47168C14.0427 2.90062 13.4611 3.14187 12.8545 3.14258C12.0978 3.14328 11.3721 3.44438 10.8369 3.97949C10.3011 4.51531 10 5.24224 10 6C10 6.75776 10.3011 7.48469 10.8369 8.02051C11.3721 8.55562 12.0978 8.85574 12.8545 8.85645C13.4611 8.85716 14.0427 9.09938 14.4717 9.52832C14.847 9.90361 15.0793 10.3954 15.1318 10.9189L15.1426 11.1455C15.1433 11.9022 15.4444 12.6279 15.9795 13.1631C16.5153 13.6989 17.2422 14 18 14C18.7578 14 19.4847 13.6989 20.0205 13.1631C20.5556 12.6279 20.8567 11.9022 20.8574 11.1455C20.8581 10.5389 21.0994 9.95726 21.5283 9.52832C21.8122 9.2444 22.1634 9.04387 22.5439 8.93945C22.8247 9.91132 22.9785 10.9377 22.9785 12L22.9727 12.3379C22.9241 13.9474 22.5276 15.471 21.8584 16.8369L22.9648 20.9639L22.9912 21.0967C23.0259 21.3642 22.9529 21.6353 22.7891 21.8496L22.7002 21.9521C22.4743 22.1778 22.1574 22.2835 21.8457 22.2432L21.7119 22.2168L17.9844 21.2168C16.2598 22.3429 14.2002 22.9999 11.9893 23C6.10876 22.9999 1.30783 18.3767 1.01367 12.5654L1 12C1 5.92597 5.91914 1.0001 11.9893 1L12.5537 1.01465Z'
                fill='url(#aiBeauty_gradient_active)'
            />
            <path
                d='M18 0C18.2273 0 18.4457 0.0902311 18.6064 0.250977C18.7671 0.411709 18.8574 0.630159 18.8574 0.857422C18.8588 1.99355 19.3109 3.08237 20.1143 3.88574C20.9176 4.68911 22.0064 5.14117 23.1426 5.14258C23.3698 5.14258 23.5883 5.2329 23.749 5.39355C23.9098 5.5543 24 5.77267 24 6C24 6.22733 23.9098 6.4457 23.749 6.60645C23.5883 6.7671 23.3698 6.85742 23.1426 6.85742C22.0064 6.85883 20.9176 7.31089 20.1143 8.11426C19.3109 8.91763 18.8588 10.0064 18.8574 11.1426C18.8574 11.3698 18.7671 11.5883 18.6064 11.749C18.4457 11.9098 18.2273 12 18 12C17.7727 12 17.5543 11.9098 17.3936 11.749C17.2329 11.5883 17.1426 11.3698 17.1426 11.1426C17.1412 10.0064 16.6891 8.91763 15.8857 8.11426C15.0824 7.31089 13.9936 6.85883 12.8574 6.85742C12.6302 6.85742 12.4117 6.7671 12.251 6.60645C12.0902 6.4457 12 6.22733 12 6C12 5.77267 12.0902 5.5543 12.251 5.39355C12.4117 5.2329 12.6302 5.14258 12.8574 5.14258C13.9936 5.14117 15.0824 4.68911 15.8857 3.88574C16.6891 3.08237 17.1412 1.99355 17.1426 0.857422C17.1426 0.630159 17.2329 0.411709 17.3936 0.250977C17.5543 0.0902311 17.7727 0 18 0Z'
                fill='black'
            />
            <defs>
                <linearGradient
                    id='aiBeauty_gradient_active'
                    x1='0.999817'
                    y1='1'
                    x2='26.9815'
                    y2='7.81095'
                    gradientUnits='userSpaceOnUse'
                >
                    <stop stopColor='#D8ACFF' />
                    <stop
                        offset='1'
                        stopColor='#FFCAA7'
                    />
                </linearGradient>
            </defs>
        </g>
    )
};

PATHS.aiBeautyBottomNav = (
    <g fill='none'>
        <path
            d='M12.5547 1.01465C13.4211 1.05861 14.2605 1.20506 15.0625 1.43848C14.9598 1.82566 14.7598 2.18357 14.4717 2.47168C14.1514 2.79192 13.7459 3.00669 13.3086 3.0957C13.0316 3.05493 12.7505 3.02655 12.4658 3.01172L11.9824 3C7.02209 3.0039 3 7.03089 3 12L3.01172 12.4775C3.25881 17.226 7.18574 20.9998 11.9893 21C13.7984 20.9999 15.4806 20.4634 16.8916 19.542L17.6396 19.0537L20.5938 19.8457L19.7334 16.6309L20.0635 15.957C20.6108 14.8398 20.9339 13.5947 20.9736 12.2773L20.9785 12L20.9668 11.5508C20.9537 11.2848 20.9272 11.0221 20.8916 10.7627C20.9709 10.2983 21.1908 9.86588 21.5283 9.52832C21.8125 9.24411 22.1639 9.0428 22.5449 8.93848C22.8258 9.91056 22.9785 10.9374 22.9785 12L22.9727 12.3379C22.9241 13.9473 22.5285 15.4711 21.8594 16.8369L22.9648 20.9639L22.9912 21.0967C23.0259 21.3642 22.953 21.6353 22.7891 21.8496L22.7002 21.9521C22.4742 22.1779 22.1575 22.2836 21.8457 22.2432L21.7119 22.2168L17.9844 21.2168C16.2598 22.3428 14.2002 22.9999 11.9893 23C6.10884 22.9998 1.3088 18.3766 1.01465 12.5654L1 12C1 5.92603 5.91922 1.0002 11.9893 1L12.5547 1.01465Z'
            fill='url(#aiBeauty_gradient_bottomnav_inactive)'
        />
        <path
            d='M18 0C18.2273 0 18.4457 0.0902311 18.6064 0.250977C18.7671 0.411709 18.8574 0.630159 18.8574 0.857422C18.8588 1.99355 19.3109 3.08237 20.1143 3.88574C20.9176 4.68911 22.0064 5.14117 23.1426 5.14258C23.3698 5.14258 23.5883 5.2329 23.749 5.39355C23.9098 5.5543 24 5.77267 24 6C24 6.22733 23.9098 6.4457 23.749 6.60645C23.5883 6.7671 23.3698 6.85742 23.1426 6.85742C22.0064 6.85883 20.9176 7.31089 20.1143 8.11426C19.3109 8.91763 18.8588 10.0064 18.8574 11.1426C18.8574 11.3698 18.7671 11.5883 18.6064 11.749C18.4457 11.9098 18.2273 12 18 12C17.7727 12 17.5543 11.9098 17.3936 11.749C17.2329 11.5883 17.1426 11.3698 17.1426 11.1426C17.1412 10.0064 16.6891 8.91763 15.8857 8.11426C15.0824 7.31089 13.9936 6.85883 12.8574 6.85742C12.6302 6.85742 12.4117 6.7671 12.251 6.60645C12.0902 6.4457 12 6.22733 12 6C12 5.77267 12.0902 5.5543 12.251 5.39355C12.4117 5.2329 12.6302 5.14258 12.8574 5.14258C13.9936 5.14117 15.0824 4.68911 15.8857 3.88574C16.6891 3.08237 17.1412 1.99355 17.1426 0.857422C17.1426 0.630159 17.2329 0.411709 17.3936 0.250977C17.5543 0.0902311 17.7727 0 18 0Z'
            fill='black'
        />
        <defs>
            <linearGradient
                id='aiBeauty_gradient_bottomnav_inactive'
                x1='1'
                y1='12'
                x2='22.9997'
                y2='12'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#D8ACFF' />
                <stop
                    offset='1'
                    stopColor='#FFCAA7'
                />
            </linearGradient>
        </defs>
    </g>
);

PATHS.aiBeautyActiveBottomNav = (
    <g fill='none'>
        <path
            d='M12.5537 1.01465C13.4204 1.05859 14.2603 1.20497 15.0625 1.43848C14.9598 1.82566 14.7598 2.18357 14.4717 2.47168C14.0427 2.90062 13.4611 3.14187 12.8545 3.14258C12.0978 3.14328 11.3721 3.44438 10.8369 3.97949C10.3011 4.51531 10 5.24224 10 6C10 6.75776 10.3011 7.48469 10.8369 8.02051C11.3721 8.55562 12.0978 8.85574 12.8545 8.85645C13.4611 8.85716 14.0427 9.09938 14.4717 9.52832C14.847 9.90361 15.0793 10.3954 15.1318 10.9189L15.1426 11.1455C15.1433 11.9022 15.4444 12.6279 15.9795 13.1631C16.5153 13.6989 17.2422 14 18 14C18.7578 14 19.4847 13.6989 20.0205 13.1631C20.5556 12.6279 20.8567 11.9022 20.8574 11.1455C20.8581 10.5389 21.0994 9.95726 21.5283 9.52832C21.8122 9.2444 22.1634 9.04387 22.5439 8.93945C22.8247 9.91132 22.9785 10.9377 22.9785 12L22.9727 12.3379C22.9241 13.9474 22.5276 15.471 21.8584 16.8369L22.9648 20.9639L22.9912 21.0967C23.0259 21.3642 22.9529 21.6353 22.7891 21.8496L22.7002 21.9521C22.4743 22.1778 22.1574 22.2835 21.8457 22.2432L21.7119 22.2168L17.9844 21.2168C16.2598 22.3429 14.2002 22.9999 11.9893 23C6.10876 22.9999 1.30783 18.3767 1.01367 12.5654L1 12C1 5.92597 5.91914 1.0001 11.9893 1L12.5537 1.01465Z'
            fill='url(#aiBeauty_gradient_bottomnav_active)'
        />
        <path
            d='M18 0C18.2273 0 18.4457 0.0902311 18.6064 0.250977C18.7671 0.411709 18.8574 0.630159 18.8574 0.857422C18.8588 1.99355 19.3109 3.08237 20.1143 3.88574C20.9176 4.68911 22.0064 5.14117 23.1426 5.14258C23.3698 5.14258 23.5883 5.2329 23.749 5.39355C23.9098 5.5543 24 5.77267 24 6C24 6.22733 23.9098 6.4457 23.749 6.60645C23.5883 6.7671 23.3698 6.85742 23.1426 6.85742C22.0064 6.85883 20.9176 7.31089 20.1143 8.11426C19.3109 8.91763 18.8588 10.0064 18.8574 11.1426C18.8574 11.3698 18.7671 11.5883 18.6064 11.749C18.4457 11.9098 18.2273 12 18 12C17.7727 12 17.5543 11.9098 17.3936 11.749C17.2329 11.5883 17.1426 11.3698 17.1426 11.1426C17.1412 10.0064 16.6891 8.91763 15.8857 8.11426C15.0824 7.31089 13.9936 6.85883 12.8574 6.85742C12.6302 6.85742 12.4117 6.7671 12.251 6.60645C12.0902 6.4457 12 6.22733 12 6C12 5.77267 12.0902 5.5543 12.251 5.39355C12.4117 5.2329 12.6302 5.14258 12.8574 5.14258C13.9936 5.14117 15.0824 4.68911 15.8857 3.88574C16.6891 3.08237 17.1412 1.99355 17.1426 0.857422C17.1426 0.630159 17.2329 0.411709 17.3936 0.250977C17.5543 0.0902311 17.7727 0 18 0Z'
            fill='black'
        />
        <defs>
            <linearGradient
                id='aiBeauty_gradient_bottomnav_active'
                x1='0.999817'
                y1='1'
                x2='26.9815'
                y2='7.81095'
                gradientUnits='userSpaceOnUse'
            >
                <stop stopColor='#D8ACFF' />
                <stop
                    offset='1'
                    stopColor='#FFCAA7'
                />
            </linearGradient>
        </defs>
    </g>
);

PATHS.eyeCrossed = (
    <g>
        {PATHS.eye}
        <line
            stroke='currentColor'
            x1='3.35355'
            y1='2.64645'
            x2='21.3536'
            y2='20.6464'
        />
    </g>
);

export default PATHS;
